import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _values from "lodash/values";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { colors } from '@nerdwallet/base-styles/variables';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { TrkElement } from '@nerdwallet/nw-client-lib/trk-helper';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import MatchScoreCTA from './match-score-cta/match-score-cta';
import { CONTENT_TABS, PREHEADER_TYPE, SENTIMENT_TYPE, TRK_PRODUCT_LOCATION, COMPONENT_ANALYTICS_NAME } from './lib/constants';
import { KetoProductCard } from './keto-product-card/keto-product-card';
import { buildTrkSectionCategory, getMonetizable } from './lib/utils';
import Preheader from './preheader';
import Content from './content';
import Drivers from './drivers';
import ExpandableContent, { DRIVER_TITLE_HEIGHT } from './expandable-content';
import Header from './header';
import ProductCtas from './product-ctas';
import mapMarketplaceEntityToProps, { DRIVER_GROUPS } from './mappings';
import styles from './marketplace-product-card.module.less';
import ProductCardImageWrapper from './product-card-image-wrapper'; // Make DRIVER_GROUPS available to implementations directly.

export { DRIVER_GROUPS };
export { CONTENT_TABS, PREHEADER_TYPE, SENTIMENT_TYPE };
export { KetoProductCard }; // exporting KetoProductCard

export var BaseMarketplaceProductCard = function BaseMarketplaceProductCard(_ref) {
  var _analytics$productCta;

  var activeContentTab = _ref.activeContentTab,
      analytics = _ref.analytics,
      bottomLine = _ref.bottomLine,
      className = _ref.className,
      cons = _ref.cons,
      ctaHref = _ref.ctaHref,
      ctaShowIcon = _ref.ctaShowIcon,
      ctaSubtext = _ref.ctaSubtext,
      ctaText = _ref.ctaText,
      drivers = _ref.drivers,
      enableAnalytics = _ref.enableAnalytics,
      hasAccordionOnMobile = _ref.hasAccordionOnMobile,
      heading = _ref.heading,
      imageData = _ref.imageData,
      initTabContentExpanded = _ref.initTabContentExpanded,
      keyFacts = _ref.keyFacts,
      marketplaceEntity = _ref.marketplaceEntity,
      marketplaceEntitySlug = _ref.marketplaceEntitySlug,
      omitCta = _ref.omitCta,
      omitRating = _ref.omitRating,
      omitRatingTextHref = _ref.omitRatingTextHref,
      omitTabs = _ref.omitTabs,
      omittedTabs = _ref.omittedTabs,
      parentImpressionId = _ref.parentImpressionId,
      productDetails = _ref.productDetails,
      productType = _ref.productType,
      pros = _ref.pros,
      reviewLinkHref = _ref.reviewLinkHref,
      reviewLinkTabIndex = _ref.reviewLinkTabIndex,
      secondaryCtaHref = _ref.secondaryCtaHref,
      secondaryCtaText = _ref.secondaryCtaText,
      shouldLogImpression = _ref.shouldLogImpression,
      starRating = _ref.starRating,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkProductPosition = _ref.trkProductPosition,
      trkSectionCategory = _ref.trkSectionCategory,
      wrapDrivers = _ref.wrapDrivers,
      _handleCcCompareClick = _ref._handleCcCompareClick,
      _hasCcCompareButton = _ref._hasCcCompareButton,
      hasPreheader = _ref.hasPreheader,
      identity = _ref.identity,
      preheaderHoverText = _ref.preheaderHoverText,
      preheaderSentiment = _ref.preheaderSentiment,
      preheaderText = _ref.preheaderText,
      preheaderType = _ref.preheaderType,
      preheaderUrl = _ref.preheaderUrl,
      showMatchScoreCTA = _ref.showMatchScoreCTA,
      _ccCompareButtonTextBeforeClick = _ref._ccCompareButtonTextBeforeClick,
      _ccCompareButtonTextAfterClick = _ref._ccCompareButtonTextAfterClick,
      lazyLoadEnabled = _ref.lazyLoadEnabled,
      displayPage = _ref.displayPage,
      isKetoCard = _ref.isKetoCard;
  var impressionContext = useContext(ImpressionContext);
  var productCardImage = /*#__PURE__*/React.createElement(ProductCardImageWrapper, {
    imageData: imageData,
    backgroundColor: colors.transparent,
    imageClassName: styles.productImage,
    className: styles.productImageWrapper,
    objectFit: "contain",
    lazyLoadEnabled: lazyLoadEnabled,
    isKetoCard: false
  });
  var mpcTrkSectionCategory = buildTrkSectionCategory(trkSectionCategory, TRK_PRODUCT_LOCATION);

  var getProductCtas = function getProductCtas(ctaClassname, ctaLocation) {
    return !omitCta ? /*#__PURE__*/React.createElement(ProductCtas, {
      analytics: analytics,
      className: ctaClassname,
      ctaHref: ctaHref,
      ctaShowIcon: ctaShowIcon,
      ctaSubtext: ctaSubtext,
      ctaText: ctaText,
      enableAnalytics: enableAnalytics,
      id: "".concat(TRK_PRODUCT_LOCATION, "__product-button--").concat(ctaLocation, "--").concat(trkProductPosition),
      marketplaceEntity: marketplaceEntity,
      reviewLinkHref: reviewLinkHref,
      secondaryCtaHref: secondaryCtaHref,
      secondaryCtaText: secondaryCtaText,
      shouldLogImpression: shouldLogImpression,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkProductPosition: trkProductPosition,
      trkSectionCategory: mpcTrkSectionCategory // BNK specific props
      ,
      displayPage: displayPage // CC specific props
      ,
      _hasCcCompareButton: _hasCcCompareButton,
      _handleCcCompareClick: _handleCcCompareClick,
      _ccCompareButtonTextBeforeClick: _ccCompareButtonTextBeforeClick,
      _ccCompareButtonTextAfterClick: _ccCompareButtonTextAfterClick
    }) : null;
  };

  var productCardPreheader = hasPreheader ? /*#__PURE__*/React.createElement(Preheader, {
    className: styles.preheader,
    taxonomy: taxonomy,
    text: preheaderText,
    title: preheaderHoverText,
    trkPageType: trkPageType,
    sentiment: preheaderSentiment,
    type: preheaderType,
    url: preheaderUrl
  }) : null;
  var matchScoreCTA = showMatchScoreCTA ? /*#__PURE__*/React.createElement(MatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    identity: identity,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy
  }) : null;
  var driversNode = /*#__PURE__*/React.createElement(Drivers, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.driversProps,
    className: styles.drivers,
    drivers: drivers,
    enableAnalytics: enableAnalytics,
    wrapDrivers: wrapDrivers
  });
  var driversAndContent = /*#__PURE__*/React.createElement(React.Fragment, null, !!drivers && driversNode, !omitTabs && !isKetoCard && /*#__PURE__*/React.createElement(Content, {
    activeContentTab: activeContentTab,
    bottomLine: bottomLine,
    cons: cons,
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.contentProps,
    enableAnalytics: enableAnalytics,
    id: marketplaceEntitySlug,
    initTabContentExpanded: initTabContentExpanded,
    keyFacts: keyFacts,
    marketplaceEntity: marketplaceEntity,
    omitExpandFunctionalityOnMobile: hasAccordionOnMobile,
    omittedTabs: omittedTabs,
    parentImpressionId: parentImpressionId,
    productDetails: productDetails,
    pros: pros,
    reviewLinkTabIndex: reviewLinkTabIndex,
    taxonomy: taxonomy,
    trkPageType: trkPageType,
    trkSectionCategory: mpcTrkSectionCategory,
    trkSectionPosition: trkProductPosition
  }));
  var isBadge = preheaderType === PREHEADER_TYPE.BADGE;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.productCard, isBadge && styles.hasPreheaderBadge, showMatchScoreCTA && styles.hasCcMatchScore])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.preheaderContainer, isBadge && styles.preheaderContainerBadge])
  }, productCardPreheader), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes('display-none', 'display-initial--wide'), styles.ccMatchScoreContainer)
  }, matchScoreCTA), /*#__PURE__*/React.createElement("div", {
    className: styles.imageWrapper
  }, _get(imageData, 'src') && (omitCta ? productCardImage : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productImage,
    marketplaceEntity: marketplaceEntity,
    monetizable: getMonetizable(marketplaceEntity),
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productCta = analytics.productCtaProps) === null || _analytics$productCta === void 0 ? void 0 : _analytics$productCta.sectionName) || COMPONENT_ANALYTICS_NAME,
    shouldLogImpression: shouldLogImpression,
    trkElement: TrkElement.image,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(mpcTrkSectionCategory, 'productImage'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK // BNK specific props
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardImage)), getProductCtas(styles['productCtas--underImage'], 'under-image')), /*#__PURE__*/React.createElement("div", {
    className: styles.headerContainer
  }, /*#__PURE__*/React.createElement(Header, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.headerProps,
    className: styles.header,
    ctaHref: ctaHref,
    enableAnalytics: enableAnalytics,
    heading: heading,
    marketplaceEntity: marketplaceEntity,
    marketplaceEntitySlug: marketplaceEntitySlug,
    productType: productType,
    omitRating: omitRating,
    omitRatingTextHref: omitRatingTextHref,
    starRating: starRating,
    reviewLinkHref: reviewLinkHref,
    omitCta: omitCta,
    shouldLogImpression: shouldLogImpression,
    taxonomy: taxonomy,
    trkPageType: trkPageType,
    trkProductPosition: trkProductPosition,
    trkSectionCategory: mpcTrkSectionCategory // BNK specific props
    ,
    displayPage: displayPage
  }), getProductCtas(styles['productCtas--underHeader'], 'under-header'), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes('display-none--wide'), styles.ccMatchScoreContainer)
  }, matchScoreCTA)), hasAccordionOnMobile && /*#__PURE__*/React.createElement(ExpandableContent, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.expandableContentProps,
    enableAnalytics: enableAnalytics,
    className: classes('display-none--wide'),
    contentCollapsedHeight: DRIVER_TITLE_HEIGHT,
    id: "QUICK-FACTS-AND-CONTENT",
    showLessText: "Hide Details",
    showMoreText: "See Details",
    trkSectionCategory: "".concat(TRK_PRODUCT_LOCATION, "__drivers--").concat(marketplaceEntitySlug),
    trkSectionPosition: trkProductPosition
  }, driversAndContent), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.driversAndContentWrapper, classes({
      'display-none': hasAccordionOnMobile
    }, {
      'display-initial--wide': hasAccordionOnMobile
    }))
  }, driversAndContent));
};
BaseMarketplaceProductCard.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Content.propTypes), Header.propTypes), Drivers.propTypes), ProductCtas.propTypes), {}, {
  className: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaShowIcon: PropTypes.bool,
  ctaSubtext: PropTypes.string,
  ctaText: PropTypes.string,
  displayPage: PropTypes.string,
  enableAnalytics: PropTypes.bool,
  hasAccordionOnMobile: PropTypes.bool,
  imageData: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntitySlug: PropTypes.string,
  omitCta: PropTypes.bool,
  omitRating: PropTypes.bool,
  omitRatingTextHref: PropTypes.bool,
  omitTabs: PropTypes.bool,
  omittedTabs: PropTypes.arrayOf(PropTypes.oneOf(_values(CONTENT_TABS))),
  productType: PropTypes.string,
  shouldLogImpression: PropTypes.bool,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkSectionCategory: PropTypes.string,
  // CC specific props
  identity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  hasPreheader: PropTypes.bool,
  matchScore: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  preheaderHoverText: PropTypes.string,
  preheaderSentiment: PropTypes.oneOf(_values(SENTIMENT_TYPE)),
  preheaderText: PropTypes.string,
  preheaderType: PropTypes.oneOf(_values(PREHEADER_TYPE)),
  preheaderUrl: PropTypes.string,
  showMatchScoreCTA: PropTypes.bool,
  // MORTG specific props
  minCreditScoreType: PropTypes.string,
  // eslint-disable-line react/no-unused-prop-types
  // Keto Card specific props
  isKetoCard: PropTypes.bool
});
BaseMarketplaceProductCard.defaultProps = {
  displayPage: '',
  enableAnalytics: false,
  hasAccordionOnMobile: false,
  hasPreheader: false,
  preheaderSentiment: SENTIMENT_TYPE.NEUTRAL,
  preheaderType: PREHEADER_TYPE.PLAIN_TEXT,
  taxonomy: _get(global.window, 'nwPageTaxonomy'),
  // CC specific props
  identity: {},
  showMatchScoreCTA: false,
  // Keto Card specific props
  isKetoCard: false
};

var MarketplaceProductCard = function MarketplaceProductCard(props) {
  useDeprecatedPropsWarning({
    component: 'MarketplaceProductCard',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }, {
      version: '6.9.0',
      deprecated: 'parentImpressionId',
      migration: 'No longer needed. React context used instead or use the MarketplaceProductCardImpression component instead.'
    }],
    props: props
  });

  if (!props.marketplaceEntity) {
    return null;
  }

  var mappedProps = mapMarketplaceEntityToProps(props);
  return /*#__PURE__*/React.createElement(BaseMarketplaceProductCard, mappedProps);
};

MarketplaceProductCard.propTypes = {
  driverGroup: PropTypes.oneOf(_values(DRIVER_GROUPS)),
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  marketplaceEntitiesForCdApyTerms: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    oneYear: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    threeYear: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    fiveYear: PropTypes.object
  }),
  wrapDrivers: PropTypes.bool,
  hidePrequalCta: PropTypes.bool,
  // Keto Card specific props
  isKetoCard: PropTypes.bool,
  // bedrock props

  /** @deprecated A flag to enable analytics */
  enableAnalytics: PropTypes.bool,

  /** @deprecated Impression id of the wrapping impression */
  parentImpressionId: PropTypes.string,
  analytics: PropTypes.shape({
    contentProps: Content.propTypes.analytics,
    driversProps: Drivers.propTypes.analytics,
    headerProps: Header.propTypes.analytics,
    matchScoreCTAProps: MatchScoreCTA.propTypes.analytics,
    productCtaProps: PropTypes.shape({
      sectionName: PropTypes.string,
      // Props passed down from the product impression used for Rates & Fees links
      payload: PropTypes.shape({
        element_position: PropTypes.number,
        section_name: PropTypes.string,
        section_position: PropTypes.number
      })
    }),

    /** @deprecated should be using the above props */
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      elementName: PropTypes.string,
      parentImpressionId: PropTypes.string
    }),
    prequalCTATrk: PropTypes.string
  }),
  lazyLoadEnabled: PropTypes.bool
};
MarketplaceProductCard.defaultProps = {
  driverGroup: DRIVER_GROUPS.DEFAULT_DRIVER_GROUP,
  marketplaceEntitiesForCdApyTerms: {},
  wrapDrivers: false,
  // CC specific props
  hidePrequalCta: false,
  // Keto Card specific props
  isKetoCard: false,
  // bedrock props
  analytics: {
    enabled: false
  },
  lazyLoadEnabled: false
};
export default MarketplaceProductCard;